import styled from 'styled-components';
import { theme } from '../../config/theme';

const CloseButton = styled.button`
  position: ${props => props.$position || 'absolute'};
  top: ${props => props.$top || '50%'};
  right: ${props => props.$right || theme.spacing.md};
  left: ${props => props.$left || 'auto'};
  bottom: ${props => props.$bottom || 'auto'};
  transform: ${props => props.$transform || 'translateY(-50%)'};
  background: ${theme.colors.primary.background};
  border: ${props => props.$borderWidth || '2px'} solid ${theme.colors.primary.buttons};
  font-size: ${props => props.$fontSize || '1.5rem'};
  cursor: pointer;
  color: ${theme.colors.primary.buttons};
  z-index: ${props => props.$zIndex || 100};
  width: ${props => props.$size || '36px'};
  height: ${props => props.$size || '36px'};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${props => props.$borderRadius || '50%'};
  transition: ${theme.transitions.default};
  box-shadow: 0 2px 10px ${theme.shadows.medium};

  &:hover {
    background: ${theme.colors.primary.buttons};
    color: ${theme.colors.primary.background};
    transform: ${props => (props.$transform || 'translateY(-50%)')} translateY(-2px);
  }

  &:active {
    transform: ${props => (props.$transform || 'translateY(-50%)')} translateY(0);
  }
  
  @media (max-width: ${theme.breakpoints.tablet}) {
    right: ${props => props.$mobileRight || theme.spacing.sm};
    width: ${props => props.$mobileSize || '32px'};
    height: ${props => props.$mobileSize || '32px'};
    font-size: ${props => props.$mobileFontSize || '1.2rem'};
  }
`;

export default CloseButton;